// Coins list - exact match from old frontend /frontend/src/App/coins.js
const coins = [
  { id: 18, preffix: "MATIC", name: "Polygon Matic", image: "POLYGON.png", min: "10", active: true, network: "MATIC" },
  { id: 19, preffix: "SHIB", name: "Shiba Inu", image: "SHIB.png", min: "1000000", active: true, network: "BSC" },
  { id: 2, preffix: "INR", name: "Indian Rupees", image: "INR.png", min: "1000", active: true, network: "UPI" },
  { id: 16, preffix: "BUSD", name: "Binance USD", image: "BUSD.png", min: "10.00000000", active: true, network: "BSC" },
  { id: 15, preffix: "USDC", name: "USDC", image: "USDC.png", min: "10.00000000", active: true, network: "BSC" },
  { id: 14, preffix: "TUSD", name: "TrueUSD", image: "TUSD.png", min: "10.00000000", active: true, network: "ERC-20" },
  { id: 81, preffix: "BDT", name: "BDT", image: "BDT.png", min: "0.00008000", active: true, network: "BDT" },
  { id: 13, preffix: "MKR", name: "Maker", image: "mkr.png", min: "0.00200000", active: true, network: "ERC-20" },
  { id: 12, preffix: "NEXO", name: "NEXO", image: "NEXO.png", min: "10.000000", active: true, network: "ERC-20" },
  { id: 11, preffix: "USDP", name: "Pax USD", image: "usdp.png", min: "1.00000000", active: true, network: "ERC-20" },
  { id: 10, preffix: "BNB", name: "Binance", image: "BNB.png", min: "0.03", active: true, network: "BSC" },
  { id: 9, preffix: "XRP", name: "Ripple", image: "XRP.png", min: "25.00000000", active: true, network: "BSC" },
  { id: 8, preffix: "ADA", name: "Cardano", image: "ADA.png", min: "25.00000000", active: true, network: "BSC" },
  { id: 7, preffix: "DOGE", name: "Dogecoin", image: "DOGE.png", min: "120.00000", active: true, network: "BSC" },
  { id: 6, preffix: "TRX", name: "TRON", image: "TRON.png", min: "140.00000", active: true, network: "TRX" },
  { id: 3, preffix: "USDT", name: "Tether", image: "TETHER.png", min: "5.00000000", active: true, network: "TRC-20" },
  { id: 20, preffix: "BCH", name: "Bitcoin Cash", image: "BCH.png", min: "0.750000", active: true, network: "BCH" },
  { id: 5, preffix: "LTC", name: "Litecoin", image: "LTC.png", min: "0.2000", active: true, network: "LTC" },
  { id: 4, preffix: "ETH", name: "Ethereum", image: "ETH.png", min: "0.0050000", active: true, network: "ETH" },
  { id: 1, preffix: "BTC", name: "Bitcoin", image: "BTC.png", min: "0.00008000", active: true, network: "BTC" },
  { id: 70, preffix: "SC", name: "SiteCoin", image: "SC.png", min: "0.00008000", active: true, network: "SC" },
];

export default coins;

// Format balance like old frontend's forceSatoshiFormat
export const formatBalance = (value, coin) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0.00";
  if (coin === "INR" || coin === "USDT" || coin === "BDT") {
    return num.toFixed(2);
  }
  return num.toFixed(8);
};
